export default __webpack_public_path__ + "static/media/our1.2d98135f.png";